export default "__VITE_ASSET__ee326df5__"